/**
 * Reading a server-sent event stream with fetch, which the AI chats use because EventSource cannot
 * POST a body or send an Authorization header: the editor's (editor-ai-stream.ts) and the
 * dashboard's results chat. Nothing here is React.
 */

export type SseFrame = { event: string; data: string };

type ParsedBuffer = { frames: SseFrame[]; rest: string };

/**
 * Splits what has arrived so far into whole frames and the unfinished remainder. A frame ends
 * at a blank line; `\r\n` is treated as `\n`, and several `data:` lines join with a newline.
 */
export const parseSseBuffer = (buffer: string): ParsedBuffer => {
  const text = buffer.replace(/\r\n/g, '\n');
  const chunks = text.split('\n\n');
  const rest = chunks.pop() ?? '';
  const frames = chunks.flatMap((chunk): SseFrame[] => {
    let event = 'message';
    const data: string[] = [];
    for (const line of chunk.split('\n')) {
      if (line.startsWith(':')) continue;
      if (line.startsWith('event:')) event = line.slice(6).trim();
      else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
    }
    return data.length > 0 ? [{ event, data: data.join('\n') }] : [];
  });
  return { frames, rest };
};
